<template>
  <div>
    <!-- header -->
    <div v-if="!($route.path == '/index' && !store.getters.getConfig.is_header)">
      <Header></Header>
      <div :class="show ? 'side-bar show' : 'side-bar'">
        <div class="side-button">
          <a-button type="primary" @click="showDrawer" class="model-button"
            ><div class="flex flex-col">
              <span class="button-text">在线客服</span>
              <a-icon :type="barvisible ? 'double-right' : 'double-left'" /></div
          ></a-button>

          <!-- <Drawer
        :visible="false"
        :closable="false"
        :height="666"
        placement="right"
        @close="close = false"
        class="button-drawer"
        :mask="false"
      >
  
      </Drawer> -->
        </div>

        <div class="side-right">
          <div class="side-header"
            ><img src="@/assets/images/headset.png" class="w-5 h-5 mr-2 ml-9" />在线客服
            <a-icon type="close" class="ml-7" @click="showDrawer" :style="{ fontSize: '13px' }"
          /></div>
          <div class="flex flex-col items-center justify-items-center">
            <h6>热线电话</h6>
            <p>{{ store.getters.getConfig.tel }}</p>
            <h6>工作时间</h6>
            <p>周一至周五（9:00-17:00)</p>
            <h6>扫一扫联系我们</h6></div
          >
          <div
            ><img
              :src="$ossUrl + store.getters.getConfig.miniapp_qrcode"
              :style="{ width: '120px' }"
              class="ml-10"
          /></div>
          <div class="side-foot"
            ><a-icon type="to-top" :style="{ fontSize: '20px' }" @click="toTop"
          /></div>
        </div>
      </div>

      <div class="h-16"></div>
      <!-- body -->
      <div style="min-height: calc(100vh - 200px)">
        <transition name="page-transition">
          <route-view />
        </transition>
      </div>
      <!-- footer -->
      <Footer></Footer>
    </div>
    
    <div v-if="($route.path == '/index' && !store.getters.getConfig.is_header)">
      <transition name="page-transition">
          <route-view />
        </transition>
    </div>
  </div>
</template>

<script>
  import Header from './content/header.vue';
  import Footer from './content/footer.vue';
  import RouteView from './RouteView';
  import store from '@/store/index';
  import { mapGetters } from 'vuex';
  export default {
    name: 'BasicLayout',
    components: { Header, Footer, RouteView },
    data() {
      return {
        collapsed: false,
        menus: [],
        barvisible: false,
        show: false,
        store: store,

      };
    },
    computed: {
      contentPaddingLeft() {
        if (!this.fixSidebar || this.isMobile()) {
          return '0';
        }
        if (this.sidebarOpened) {
          return '180px';
        }
        return '80px';
      },
      ...mapGetters(['getToken']),
    },
    watch: {},
    created() {},
    mounted() {

      if (this.getToken) {
        this.$store.dispatch('user/getUserInfoAction');
      }
      console.log(this.$route.path);
    },
    methods: {
      toTop() {
        document.documentElement.scrollTop = 0;
      },
      afterVisibleChange(val) {
        console.log('visible', val);
      },
      showDrawer() {
        if (this.barvisible == true) {
          this.barvisible = false;
          this.show = false;
        } else {
          this.barvisible = true;
          this.show = true;
        }
      },
      onClose() {
        this.barvisible = false;
        this.show = false;
      },
    },
  };
</script>

<style lang="less">
  /*
  * The following styles are auto-applied to elements with
  * transition="page-transition" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the page transition by editing
  * these styles.
  */

  .page-transition-enter {
    opacity: 0;
  }

  .page-transition-leave-active {
    opacity: 0;
  }

  .page-transition-enter .page-transition-container,
  .page-transition-leave-active .page-transition-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .model-button {
    border-color: #415695 !important;
    background-color: #415695 !important;
    height: 120px !important;
    width: 40px !important;
  }
  .side-button {
    margin-top: 150px;
  }
  .button-text {
    padding-right: 50px;
    font-weight: 700;
    line-height: 21px;
    white-space: normal;
    width: 40px;
    padding-bottom: 2px;
  }
  .button-drawer {
    height: 500px !important;
  }

  .side-right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 180px;
    height: 400px;
    border: 1px solid #34478f;
    background: white;
    // background-color: #34478f;
  }

  .side-bar {
    display: flex;
    height: 500px;
    position: fixed;
    z-index: 1000;
    right: -183px;
    top: 35vh;
    transition: right 0.5s;
  }

  .show {
    right: 0px;
  }

  .side-header {
    display: flex;

    align-items: center;
    height: 35px;
    background: #34478f;
    line-height: 35px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
  }

  .side-foot {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    background: #34478f;
    line-height: 35px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
  }
</style>
